import { CreateStore, SnexThunkMiddleware } from 'phoenix/redux/configureStore';
import { SetDebugArrayPersist, SetDebugPersist, SetDebugStringPersist } from 'phoenix/util';
import { useDispatch } from 'react-redux';
import { applyMiddleware } from 'redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';

// Lives apart from AppRoot so that importing the store does not pull in the screen tree.
// AppRoot imports screens, which import components, which import AppRoot again — a cycle that
// made every component test load the whole app. See .claude/docs/testing/coverage-plan.md.

export const store = CreateStore(() => {
    // Startup.tsx has not installed the debug storage driver at this point, so read localStorage directly.
    const enabled = localStorage.getItem('SHOW_REDUX_LOGGING') === 'Y';
    const snexThunk = thunk as SnexThunkMiddleware;
    if (enabled) {
        return applyMiddleware(snexThunk, createLogger({ collapsed: true }));
    } else {
        return applyMiddleware(snexThunk);
    }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;

SetDebugPersist({
    get: (key) => localStorage.getItem(key) === 'Y',
    set: (key, value) => localStorage.setItem(key, value ? 'Y' : 'N')
});

SetDebugStringPersist({
    get: (key) => localStorage.getItem(key),
    set: (key, value) => localStorage.setItem(key, `${value}`)
});

SetDebugArrayPersist({
    get: (key) => JSON.parse(localStorage.getItem(key) || '[]') || [],
    set: (key, value) => localStorage.setItem(key, JSON.stringify(value))
});
